import { RiErrorWarningLine } from "react-icons/ri";

import { Button, Flex, Icon, Tooltip, Text, Box } from "@chakra-ui/react";

const Information = ({ title, icon, isActive, onClick, pendente, height }) => {
  return (
    <Flex justifyContent={"center"}>
      <Button
        position={"relative"}
        whiteSpace={"break-spaces"}
        display={"flex"}
        px={0}
        flexDirection={"column"}
        variant="solid"
        height={height ? "auto" : "70px"}
        width={"130px"}
        bgColor="#ECECEC"
        fontWeight={400}
        boxShadow={isActive ? "dark-lg" : "none"}
        outline={isActive ? "3px solid #4299e199" : "none"}
        fontSize={{ base: "12px", "2xl": "14px" }}
        py={{ base: "1px", "2xl": 2 }}
        lineHeight="18px"
        _focus={{ borderColor: "none" }}
        _hover={{ bgColor: "#DDEBEA" }}
        _active={{ bgColor: "#DDEBEA" }}
        isActive={isActive}
        borderRadius="7px"
        onClick={onClick}
      >
        {icon}

        {pendente && (
          <Tooltip label="Pendências" fontSize="md" placement={"top"}>
            <span style={{ position: "absolute", right: "25px", top: 0 }}>
              {typeof pendente === "number" ? (
                <Box
                  mt={"3px"}
                  p={2}
                  aria-label="Aviso de pendente"
                  color="#D80000"
                  border="2px solid #D80000"
                  borderRadius="full"
                  boxSize="16.67px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="10px"
                  fontWeight="bold"
                >
                  {pendente}
                </Box>
              ) : (
                <Icon
                  aria-label="Aviso de pendente"
                  color="#D80000"
                  as={RiErrorWarningLine}
                  boxSize="20px"
                />
              )}
            </span>
          </Tooltip>
        )}

        <Text>{title}</Text>
      </Button>
    </Flex>
  );
};

export default Information;
